module.exports = __webpack_public_path__ + "img/dupplicate-icon.93bb1e38.svg";